import { render, staticRenderFns } from "./BaseButtonServiceSaas.vue?vue&type=template&id=41e528da&"
import script from "./BaseButtonServiceSaas.vue?vue&type=script&lang=js&"
export * from "./BaseButtonServiceSaas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports